import { useState } from "react";

import LifecycleConfirmModal from "../../realty/widgets/LifecycleConfirmModal";

function DetailActionModals({
  isOwner,
  property,
  onConfirmPublish,
  onConfirmUnpublish,
  onConfirmReserve,
  onConfirmSold,
  onConfirmArchive,
  onConfirmReactivate,
  onConfirmDelete,
  isMutatingStatus = false,
  isDeleting = false,
  onConfirmFollow,
  isFollowingPending = false,
  followAlreadyFollowing = false,
  complaintCategories = [],
  complaintCategoriesError = null,
  onSubmitComplaint,
  isReportingComplaint = false,
  complaintError = null,
  complaintSuccess = false,
}) {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [complaintDescription, setComplaintDescription] = useState("");
  const isBusy = Boolean(isMutatingStatus || isDeleting);
  const reactivateActionId =
    property && property.status === "reserved" ? "return_active" : "reactivate";

  const handleComplaintSubmit = (e) => {
    e.preventDefault();
    if (
      !selectedCategoryId ||
      isReportingComplaint ||
      typeof onSubmitComplaint !== "function"
    ) {
      return;
    }
    onSubmitComplaint({
      categoryId: selectedCategoryId,
      description: complaintDescription,
    });
  };

  return (
    <div className="modals">
      {isOwner ? (
        <>
          <LifecycleConfirmModal
            id="content-setting-publish"
            actionId="publish"
            property={property}
            onConfirm={onConfirmPublish}
            isBusy={isBusy}
          />
          <LifecycleConfirmModal
            id="content-setting-unpublish"
            actionId="unpublish"
            property={property}
            onConfirm={onConfirmUnpublish}
            isBusy={isBusy}
            confirmClassName="action-btn action-btn--accent"
          />
          <LifecycleConfirmModal
            id="content-setting-reserve"
            actionId="reserve"
            property={property}
            onConfirm={onConfirmReserve}
            isBusy={isBusy}
          />
          <LifecycleConfirmModal
            id="content-setting-sold-out"
            actionId="sold"
            property={property}
            onConfirm={onConfirmSold}
            isBusy={isBusy}
          />
          <LifecycleConfirmModal
            id="content-setting-archive"
            actionId="archive"
            property={property}
            onConfirm={onConfirmArchive}
            isBusy={isBusy}
            confirmClassName="action-btn action-btn--accent"
          />
          <LifecycleConfirmModal
            id="content-setting-reactivate"
            actionId={reactivateActionId}
            property={property}
            onConfirm={onConfirmReactivate}
            isBusy={isBusy}
          />
          <LifecycleConfirmModal
            id="content-setting-delete"
            actionId="delete"
            property={property}
            onConfirm={onConfirmDelete}
            isBusy={isBusy}
            confirmClassName="action-btn action-btn--danger"
          />
        </>
      ) : (
        <>
          <div
            className="modal fade project-modal"
            id="content-setting-follow"
            tabIndex={-1}
            aria-labelledby="content-setting-follow"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="modal-title">Стежити</h3>
                  <div
                    className="modal-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="fa-solid fa-xmark fa-2x" aria-hidden="true" />
                  </div>
                </div>
                <div className="modal-body">
                  <p>Ви хочете стежити за даним користувачем?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Закрити
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={onConfirmFollow}
                    disabled={isFollowingPending || followAlreadyFollowing}
                  >
                    Так
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade project-modal"
            id="content-setting-complaint"
            tabIndex={-1}
            aria-labelledby="content-setting-complaint"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="modal-title">Поскаржитися</h3>
                  <div
                    className="modal-btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="fa-solid fa-xmark fa-2x" aria-hidden="true" />
                  </div>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleComplaintSubmit}>
                    {complaintCategoriesError ? (
                      <p className="actions-panel__error" role="alert">
                        {complaintCategoriesError}
                      </p>
                    ) : null}
                    {complaintCategories.length === 0 &&
                    !complaintCategoriesError ? (
                      <p className="muted">
                        <span>—</span>
                      </p>
                    ) : null}
                    {complaintCategories.map((category) => {
                      const radioId = `content-complaint-category-${category.id}`;
                      return (
                        <div key={category.id} className="mb-3 form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id={radioId}
                            name="content-complaint-category"
                            value={category.id}
                            checked={selectedCategoryId === category.id}
                            onChange={() => setSelectedCategoryId(category.id)}
                            disabled={isReportingComplaint}
                          />
                          <label className="form-check-label" htmlFor={radioId}>
                            {category.name}
                          </label>
                        </div>
                      );
                    })}
                    <div className="mb-3">
                      <label
                        htmlFor="content-FormControlTextarea1"
                        className="form-label"
                      >
                        Інше:
                      </label>
                      <textarea
                        className="form-control"
                        id="content-FormControlTextarea1"
                        rows={3}
                        value={complaintDescription}
                        onChange={(e) => setComplaintDescription(e.target.value)}
                        disabled={isReportingComplaint}
                      />
                    </div>
                    <button
                      type="submit"
                      className="form-btn"
                      disabled={
                        !selectedCategoryId ||
                        isReportingComplaint ||
                        complaintSuccess
                      }
                    >
                      Надіслати
                    </button>
                    {complaintError ? (
                      <p className="actions-panel__error" role="alert">
                        {complaintError}
                      </p>
                    ) : null}
                    {complaintSuccess ? (
                      <p className="actions-panel__success" role="status">
                        Скаргу надіслано на розгляд модераторів.
                      </p>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DetailActionModals;
